import { render, staticRenderFns } from "./RefLager.vue?vue&type=template&id=0657f813&scoped=true&"
import script from "./RefLager.vue?vue&type=script&lang=js&"
export * from "./RefLager.vue?vue&type=script&lang=js&"
import style0 from "./RefLager.vue?vue&type=style&index=0&id=0657f813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657f813",
  null
  
)

export default component.exports